import React from 'react';

import Select, { SelectProps, MIN_SEARCH_CHARS, SelectRef } from './Select';
import { SHOWN_OPTIONS_COUNT } from './Listor';
import Option from './Option';
import OptGroup from './OptGroup';

import SelectStore from './hooks/useStore';
import { SelectOptionType } from './types';

export * from './types';

export { mergeOptions } from './util';

export type { SelectProps, SelectRef };

export { MIN_SEARCH_CHARS as SELECT_MIN_SEARCH_CHARS };
export { SHOWN_OPTIONS_COUNT as SELECT_SHOWN_OPTIONS_COUNT };

SelectWrap.Option = Option;
SelectWrap.OptGroup = OptGroup;

function SelectWrap<T extends SelectOptionType>(props: SelectProps<T>) {
  return (
    <SelectStore.Provider>
      <Select<T> {...props} />
    </SelectStore.Provider>
  );
}

export default SelectWrap;
